import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { createPortal } from 'react-dom';
import { Sheet, SecondaryView, Modal } from '@amzn/storm-ui';
import { F as FormLayoutPopperWrapper } from './FormLayoutPopperWrapper-DQZPaJ9e.js';
import { u as useFormStage } from './hooks/useStage-C5gC2haD.js';
import { F as FormLayoutMobileIntro } from './FormLayoutMobileIntro-BZRibC1Y.js';
import { i as InlineWrapper, j as SecondaryViewWrapper } from './FormLayout.styles-BzYy_4z2.js';

const FormLayoutWrapper = ({
  anchorElement,
  children,
  isMobile,
  type,
  isOpen,
  isPlaceholder = false,
  mobileCloseButtonLabel = 'Back',
  mobileShareButtonLabel,
  onClose,
  renderMobileIntroHeader = 'Share your feedback with us',
  renderIntro,
  popperOffset = [0, 0],
  popperPlacement = 'left-end',
  popperPortalElementId,
  popperStrategy = 'fixed',
  popperStyle,
  ...restProps
}) => {
  const {
    stage
  } = useFormStage();
  if (type === 'inline') {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, anchorElement !== null && anchorElement !== void 0 && anchorElement.current ? /*#__PURE__*/createPortal(/*#__PURE__*/React__default.createElement(InlineWrapper, restProps, children), anchorElement.current) : null);
  }
  if (isMobile) {
    if (isPlaceholder) {
      return /*#__PURE__*/React__default.createElement(Sheet, _extends({}, restProps, {
        isOpen: isOpen,
        onClose: () => {
          if (typeof onClose === 'function') {
            onClose();
          }
        },
        closeButton: {
          type: 'icon',
          label: mobileCloseButtonLabel
        },
        side: "bottom",
        type: "light",
        toggleEl: anchorElement
      }), children);
    }
    if (stage === 'intro' || stage === 'submitted') {
      return /*#__PURE__*/React__default.createElement(Sheet, _extends({}, restProps, {
        isOpen: isOpen,
        onClose: () => {
          if (typeof onClose === 'function') {
            onClose();
          }
        },
        closeButton: {
          type: 'icon',
          label: mobileCloseButtonLabel
        },
        side: "bottom",
        type: "light",
        toggleEl: anchorElement
      }), stage === 'intro' ? /*#__PURE__*/React__default.createElement(FormLayoutMobileIntro, {
        mobileShareButtonLabel: mobileShareButtonLabel,
        renderIntro: renderIntro,
        renderHeader: renderMobileIntroHeader
      }) : children);
    }
    return /*#__PURE__*/React__default.createElement(SecondaryView, _extends({}, restProps, {
      closeButtonLabel: mobileCloseButtonLabel,
      isOpen: isOpen,
      onClose: event => {
        if (typeof onClose === 'function') {
          onClose(event);
        }
      },
      padding: "none",
      toggleEl: anchorElement
    }), /*#__PURE__*/React__default.createElement(SecondaryViewWrapper, null, children));
  }
  if (type === 'modal') {
    return /*#__PURE__*/React__default.createElement(Modal, _extends({}, restProps, {
      isOpen: isOpen,
      onClose: () => {
        if (typeof onClose === 'function') {
          onClose();
        }
      },
      padding: "none",
      toggleEl: anchorElement,
      hasCloseButton: false
    }), children);
  }
  return /*#__PURE__*/React__default.createElement(FormLayoutPopperWrapper, _extends({}, restProps, {
    isOpen: isOpen,
    anchorElement: anchorElement === null || anchorElement === void 0 ? void 0 : anchorElement.current,
    offset: popperOffset,
    placement: popperPlacement,
    portalElementId: popperPortalElementId,
    strategy: popperStrategy,
    style: popperStyle
  }), children);
};

export { FormLayoutWrapper as F };
//# sourceMappingURL=FormLayoutWrapper-BLcX_Mmv.js.map
